// extracted by mini-css-extract-plugin
export default {"tableWrap":"styles_tableWrap__Xxl2N","table":"styles_table__MpHGa","header":"styles_header__7VqiJ"};